import React from 'react'

// Título de sección de cada paso del editor. El tamaño responsive vive en
// `.stepSectionTitle` (campaignManagerStyle.js).
const StepTitle = ({children}) => {
  return (
    <p className="stepSectionTitle">{children}</p>
  )
}

export default StepTitle
